import GridContainer from "Components/Grids/grid-container";
import React from "react";
import { useTranslation } from "react-i18next";
import SBSObjectList from "./sbs-object-list";

const SbsObjectListContainer: () => JSX.Element = (): JSX.Element => {
  const { t } = useTranslation(["commonResources"]);

  return (
    <React.Fragment>
      <GridContainer title={t("sbsObjectForm.title")}>
        <SBSObjectList enableEdit={true} />
      </GridContainer>
    </React.Fragment>
  );
};

export default SbsObjectListContainer;
